module.exports = __webpack_public_path__ + "static/img/1111.b45b0f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/1111.jpg
// module id = Tfkq
// module chunks = 1